import { useAuditApi } from "./common/auditApi";

export function useInboundDeliveryAuditApi() {
  return useAuditApi({
    url: 'delivery/inbound',
    translateTitle: (t) => t.audit.actions.fetchInboundDelivery.title,
    translateError: (t) => t.audit.actions.fetchInboundDelivery.error
  });
}
